<template>
  <BaseLayout>
    <div class="relative bg-white overflow-hidden">
      <div class="relative pt-6 pb-16 sm:pb-24 lg:pb-32">
        <div>
          <nav
            class="relative max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6"
            aria-label="Global"
          >
            <div class="flex items-center flex-1">
              <div class="flex items-center justify-between w-full md:w-auto">
                <a href="/">
                  <span class="sr-only">Workflow</span>
                  <img
                    class="h-8 w-auto sm:h-10"
                    :src="require(`@/assets/img/fitclas.png`)"
                    alt=""
                  />
                </a>
              </div>
            </div>
          </nav>
        </div>

        <main class="mt-16 mx-auto max-w-7xl px-4 sm:mt-24 sm:px-6 lg:mt-32">
          <div class="lg:grid lg:grid-cols-12 lg:gap-8">
            <div
              class="sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left"
            >
              <h1>
                <span
                  class="mt-1 block text-4xl tracking-tight font-extrabold sm:text-5xl xl:text-4xl"
                >
                  <span class="block text-gray-800"
                    >This page is under construction</span
                  >
                </span>
              </h1>
              <p
                class="mt-3 text-base text-gray-600 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl font-bold"
              >
                We're working on it!
              </p>
              <div
                class="mt-8 sm:max-w-lg sm:mx-auto sm:text-center lg:text-left lg:mx-0"
              >
                <p class="text-base font-medium text-gray-800">
                  Want to be the first to know when the site is live?
                </p>
                <form
                  ref="anyName"
                  class="mt-3"
                  @submit.prevent="submitHandler"
                >
                  <div class="relative text-gray-700">
                    <input
                      type="text"
                      class="w-full h-10 pl-3 pr-8 text-base placeholder-gray-600 ring-1 rounded-lg focus:shadow-outline"
                      placeholder="Enter your Email here"
                      v-model="$v.email.$model"
                      :class="{ 'ring-red-700': $v.email.$error }"
                    />
                    <button
                      type="submit"
                      class="absolute inset-y-0 right-0 flex items-center px-2 font-bold text-white bg-green-light rounded-r-lg hover:bg-green-light focus:bg-green-light"
                    >
                      Subscribe Now
                    </button>
                  </div>
                  <div v-if="$v.email.$error">
                    <small class="text-red-700" v-if="!$v.email.required">
                      Email field is required.
                    </small>
                    <small class="text-red-700" v-if="!$v.email.email">
                      Accepts valid email addresses.
                    </small>
                  </div>
                </form>
              </div>
            </div>
            <div
              class="mt-12 relative sm:max-w-lg sm:mx-auto lg:mt-0 lg:max-w-none lg:mx-0 lg:col-span-6 lg:flex lg:items-center"
            >
              <svg
                class="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-8 scale-75 origin-top sm:scale-100 lg:hidden"
                width="640"
                height="784"
                fill="none"
                viewBox="0 0 640 784"
                aria-hidden="true"
              >
                <defs>
                  <pattern
                    id="4f4f415c-a0e9-44c2-9601-6ded5a34a13e"
                    x="118"
                    y="0"
                    width="20"
                    height="20"
                    patternUnits="userSpaceOnUse"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="4"
                      height="4"
                      class="text-gray-200"
                      fill="currentColor"
                    />
                  </pattern>
                </defs>
                <rect
                  y="72"
                  width="640"
                  height="640"
                  class="text-gray-50"
                  fill="currentColor"
                />
                <rect
                  x="118"
                  width="404"
                  height="784"
                  fill="url(#4f4f415c-a0e9-44c2-9601-6ded5a34a13e)"
                />
              </svg>
              <div
                class="relative mx-auto w-full rounded-lg shadow-lg lg:max-w-md"
              >
                <button
                  type="button"
                  class="relative block w-full bg-white rounded-lg overflow-hidden focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  <span class="sr-only">Watch our video to learn more</span>
                  <img
                    class="w-full"
                    :src="require(`@/assets/svg/sign-up.svg`)"
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import BaseLayout from "@/components/layouts/BaseLayout";
import { required, email } from "vuelidate/lib/validators";
import { mapActions } from "vuex";

export default {
  name: "Registration",
  components: {
    BaseLayout,
  },
  data() {
    return {
      email: null,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  methods: {
    ...mapActions(["postSubscribe"]),

    async submitHandler() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        console.log("invalid");
      } else {
        const data = {
          email: this.email,
        };
        this.postSubscribe(data)
          .then(() => {
            this.$refs.anyName.reset();
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
  },
};
</script>